import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AICoreServices.css"

import analytic from "../../assests/Agentic_AI.svg"; 
import Natural from "../../assests/analysis.svg"
import TexttoSpeech from "../../assests/MLOps.svg" 
import ComputerVision from "../../assests/IntelligentProcess.svg"
import CustomLLM from "../../assests/Custom-LLM.svg"
import GenerativeAI from "../../assests/Generative-AI.svg"
import AgenticAI from "../../assests/Agentic-AI.svg"; 
const AICoreServices = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <section className="pt-5 ai-section">
        <h2 className="text-center mb-2  aicore-h2">Performance & Intelligence at Scale </h2>
        <p className="text-center performance-p-ai mb-5">Automate tasks | Predict outcomes | Optimize workflows</p>

        {/* IoT Solutions */}
        <Row className="align-items-center mb-4  card-image-1-1 card-padding">
          <Col md={7} xs={12}>
            <div className="py-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">Generative & Agentic AI</h4>
              <ul className="mb-0 aicore-ul">
                <li>
                 Deploy <span className="bold-span">AI solutions that autonomously generate content, insights, and business recommendations</span>.  
                </li>
                <li>
                  Enable organizations <span className="bold-span">to accelerate innovation and reduce manual decision-making</span>. 
                </li>
                {/* <li>
                  Develop regression, classification, and clustering models for diverse business problems. 
                </li>
                <li>
                  Provide dashboards and visualizations to<span className="bold-span"> transform insights into action</span>. 
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img src={analytic} alt="Predictive-Analytics" className="img-fluid" />
          </Col>
        </Row>

        {/* Robotics Solutions */}
        <Row className="align-items-center mb-4 flex-md-row-reverse  card-image-2-1 card-padding">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">Advanced Analytics & Insights</h4>
              <ul className="mb-0 aicore-ul">
                <li>
                  Apply <span className="bold-span">predictive and prescriptive analytics </span>to forecast trends and uncover business opportunities
                </li>
                <li>
                  Provide <span className="bold-span">data-driven insights</span> to enhance operational efficiency and growth.
                </li>
                {/* <li>
                  Extract insights from unstructured text data to <span className="bold-span">improve business strategies</span>. 
                </li>
                <li>
                  Enhance user engagement through<span className="bold-span"> conversational AI</span> experiences. 
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={Natural}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>

        <Row className="align-items-center mb-4   card-image-3-1 card-padding">
          <Col md={7} xs={12}>
            <div className="py-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">MLOps & AI Platforms</h4>
              <ul className="mb-0 aicore-ul">
                <li>
                  Build and manage<span className="bold-span"> robust ML pipelines and AI platforms</span> for scalable model deployment. 
                </li>
                <li>
                  Ensure <span className="bold-span">reliable, high-performance AI solutions </span>across cloud and on-premise environments. 
                </li>
                {/* <li>
                  Ideal for <span className="bold-span">customer support chatbots</span>, IVR, and digital assistants. 
                </li>
                <li>
                  Enhance e-learning with audio content for accessibility. 
                </li>
                <li>
                  Add lifelike narration to <span className="bold-span">digital platforms and content</span>. 
                </li>
                <li>
                  Improve inclusivity with voice-enabled applications.
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img
              src={TexttoSpeech}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>


        <Row className="align-items-center mb-4 flex-md-row-reverse  card-image-4-1 card-padding">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">Intelligent Process Automation </h4>
              <ul className="mb-0 aicore-ul">
                <li>
                  Automate repetitive business processes using <span className="bold-span">RPA and AI-driven workflows</span>. 
                </li>
                <li>
                  Increase productivity, reduce human error, and <span className="bold-span">streamline operations</span>. 
                </li>
                {/* <li>
                  Facial recognition for authentication, security, and personalization. 
                </li>
                <li>
                  Automated defect detection to <span className="bold-span">improve quality control</span> in manufacturing. 
                </li>
                <li>
                  Intelligent <span className="bold-span">video monitoring and surveillance</span> for safety and compliance. 
                </li>
                <li>
                  Industry-ready solutions for manufacturing, retail, security, and healthcare. 
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={ComputerVision}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>



        {/* <Row className="align-items-center mb-4   card-image-5-1 card-padding">
          <Col md={7} xs={12}>
            <div className="py-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">Custom LLM Training & Deployment </h4>
              <ul className="mb-0 aicore-ul">
                <li>
                  <span className="bold-span">Train Large Language Models</span> (LLMs) on your proprietary datasets.  
                </li>
                <li>
                  Fine-tune models for domain-specific accuracy. 
                </li>
                <li>
                  Ensure secure and <span className="bold-span">scalable deployments</span> on cloud or <span className="bold-span">on-premise</span>. 
                </li>
                <li>
                  Build AI solutions aligned with your unique workflows and goals. 
                </li>
                <li>
                 Increase reliability and trust by customizing models for business use. 
                </li>
                <li>
                  End-to-end support from <span className="bold-span">training to live deployment</span>. 
                </li>
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img
              src={CustomLLM}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>


        <Row className="align-items-center mb-4 flex-md-row-reverse  card-image-6-1 card-padding">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">Generative AI  </h4>
              <ul className="mb-0 aicore-ul">
                <li>
                  <span className="bold-span">Automate content generation </span>for text, design, code, and media. 
                </li>
                <li>
                  Speed up innovation with <span className="bold-span">AI-driven</span> idea creation and simulation. 
                </li>
                <li>
                  Reduce cost and manual effort in creative processes. 
                </li>
                <li>
                  Enable personalization at scale with adaptive outputs. 
                </li>
                <li>
                  Boost marketing, product design, and R&D workflows. 
                </li>
                <li>
                  Reimagine how businesses <span className="bold-span">create, design, and innovate</span>. 
                </li>
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={GenerativeAI}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>


        <Row className="align-items-center mb-4   card-image-7-1 card-padding">
          <Col md={7} xs={12}>
            <div className="py-4  h-100 text-start ai-text">
              <h4 className=" mb-4 aicore-h4">Agentic AI  </h4>
              <ul className="mb-0 aicore-ul">
                <li>
                  Deploy autonomous AI agents that can reason, plan, and act.  
                </li>
                <li>
                  Learn from real-time context and <span className="bold-span">adapt dynamically</span>. 
                </li>
                <li>
                  Execute complex workflows with minimal human input. 
                </li>
                <li>
                  Deliver proactive customer support with self-learning AI. 
                </li>
                <li>
                 Automate operations management and decision-making.
                </li>
                <li>
                  Build a <span className="bold-span">digital workforce </span>of intelligent AI co-pilots. 
                </li>
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end  mt-3 mt-md-0">
            <img
              src={AgenticAI}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row> */}
    </section>
    </div>
  );
};

export default AICoreServices;
